import React from 'react';
import { WidgetProps } from '@rjsf/core';
import { Form } from 'semantic-ui-react'
import { useSchemaTranslation } from '../../../useSchemaTranslation';
type TOption = { label: string, value: any };

const RadioDisplay = ({
  id,
  options,
  value,
  formContext,
  placeholder = "-"
}: WidgetProps) => {
  const { t } = useSchemaTranslation();
  const enumOptions = options.enumOptions as TOption[];


  const inline = Boolean(options.inline)

  return (
    <Form.Group id={id} className="RadioDisplay field-radio-group" inline={inline} grouped={!inline}>
      {enumOptions.length ?
        enumOptions.map((option: any, i: number) => {
          const checked = option.value === value;

          return checked ? <div key={i}>{t(option.label)}</div> : null;

        })
        : placeholder || formContext.emptyValue}
    </Form.Group>
  );
};

export default RadioDisplay;
